import { initializeApp } from 'firebase/app';
const firebaseConfig = {
  apiKey: process.env.VUE_APP_AUTH_API_KEY.toString(),
  authDomain: process.env.VUE_APP_AUTH_API_DOMAIN.toString(),
};
initializeApp(firebaseConfig);
